<template>
  <div
    class="site-wrapper"
    :class="{ 'site-sidebar--fold': sidebarFold }"
    v-loading.fullscreen.lock="loading"
    element-loading-text="拼命加载中">
    <template v-if="!loading" style="margin-bottom:100px;">
      <main-navbar />
      <main-sidebar v-if="hasLogin" ref='mychild'/>
      <div class="site-content__wrapper">
      <!-- <div class="site-content__wrapper" v-if="hasLogin" :style="{ 'min-height': documentClientHeight + 'px' }"> -->
        <main-content />
      </div>
    </template>
  </div>
</template>
<script>

  import MainNavbar from './main-navbar'
  import MainSidebar from './main-sidebar'
  import MainContent from './main-content'
  import {loginHttp,logout} from '@/utils/login'
  import {mapState} from "vuex";
  import {isURL} from '@/utils/validate'

  export default {
    data () {
      return {
        loading:false,
        typeIdArr:[], //角色类型
        role:'',
        roleId:'',//审核人
        roleNo:'',
        roleUserTypeList:'',
        roleUserType:'',
      }
    },
    components: {
      MainNavbar,
      MainSidebar,
      MainContent
    },
    computed: {
      documentClientHeight: {
        get () { return this.$store.state.common.documentClientHeight },
        set (val) { this.$store.commit('common/updateDocumentClientHeight', val) }
      },
      sidebarFold: {
        get () {
          return this.$store.state.common.sidebarFold
        }
      },
      hasLogin: {
        get () {
          return this.$store.state.user.id !== ''  && this.$store.state.user.id !== undefined
        }
      },
      userId: {
        get () { return this.$store.state.user.id },
        set (val) { this.$store.commit('user/updateId', val) }
      },
      userName: {
        get () { return this.$store.state.user.name },
        set (val) { this.$store.commit('user/updateName', val) }
      },
      displayName: {
        get () { return this.$store.state.user.displayName },
        set (val) { this.$store.commit('user/updateDisplayName', val) }
      },
       ...mapState({
              stateData:state=>state.user
          })
    },
    created () {
      this.roleNo =  this.stateData.noRoleId//没有角色权限
      this.loading=true;
      this.getUserInfo();
      var roleData = this.stateData.orgInternalRoleIds //角色类型数组

      this.getTransactionCenterList()
      this.getAppList()


    },
    mounted () {
      this.resetDocumentClientHeight();
      window.addEventListener('message', this.handleEventListenerFn)
    },
    methods: {
      handleEventListenerFn(event){
        if(event.data=='logout'){
          logout()
        }
      },
      compare(property){ //排序
          return function(a,b){
              var value1 = a[property];
              var value2 = b[property];
              return value1 - value2;
          }
      },
      selectClick(val){ //角色选取console.log(val)
            console.log(val)
            sessionStorage.setItem('roleUserType', JSON.stringify(val));
            this.tabsCloseAllHandleCurrent() //关闭所有打开的标签回到首页
            this.loading=true;
            this.$http.get('/sys/cmscontent/updateSelectInternalRole?selectInternalRoleId='+val).then(res=>{
                if(res.data.code == 1){
                  this.$store.commit('user/updatePageRoleIdsNum', res.data.data) //获取角色权限

                    loginHttp({
                        url: '/loadMenus',
                        method: 'post',
                    }).then(({data}) => {
                        this.loading=false
                        this.$store.commit('common/updateMenuList', JSON.stringify(data.menuList || '[]'))
                        sessionStorage.setItem('menuList', JSON.stringify(data.menuList || '[]'))
                        this.fnAddDynamicMenuRoutes(data.menuList)

                    }).catch((e) => {

                    })
                }
            })
        },
        fnAddDynamicMenuRoutes(menuList = []) {
            let routes = []
            this.fnAddDynamicMenuRoutesCicle(menuList, routes)
        },
        fnAddDynamicMenuRoutesCicle(menuList = [], routes = []) {
            var temp = []
            let funcList = []
            for (var i = 0; i < menuList.length; i++) {
                let menuItem = menuList[i]
                if (menuItem.list && menuItem.list.length >= 1) {
                    temp = temp.concat(menuItem.list)
                } else if (menuItem.url && /\S/.test(menuItem.url)) {
                    if (menuItem.funcList && menuItem.funcList.length >= 1) {
                        funcList = funcList.concat(menuItem.funcList)
                    }
                    //有明确路由名称的表示静态路由
                    if (menuItem.routeName) {
                        continue
                    }
                    menuItem.url = menuItem.url.replace(/^\//, '')
                    let url = menuItem.url
                    let argIndex = url.indexOf('?')
                    if (argIndex > 0) {
                        url = url.substr(0, argIndex)
                    }
                    let routePath = url.replace('/', '-')
                    var route = {
                        path: routePath,
                        component: null,
                        name: routePath,
                        meta: {
                            menuId: menuItem.menuId,
                            title: menuItem.name,
                            isDynamic: true,
                            isTab: true,
                            iframeUrl: ''
                        }
                    }
                    // url以http[s]://开头, 通过iframe展示
                    if (isURL(menuItem.url)) {
                        route['path'] = `i-${menuItem.menuId}`
                        route['name'] = `i-${menuItem.menuId}`
                        route['meta']['iframeUrl'] = menuItem.url
                    } else {
                        try {
                            route['component'] = _import(`modules/${url}`) || null
                        } catch (e) {
                        }
                    }
                    routes.push(route)
                    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(routes || '[]'))
                }
            }
            if (temp.length >= 1) {
                this.fnAddDynamicMenuRoutesCicle(temp, routes)
            }
            if (funcList.length >= 1) {
                this.fnAddDynamicMenuRoutesCicle(funcList, routes)
            }
        },
      // 重置窗口可视高度
      resetDocumentClientHeight () {
        this.documentClientHeight = document.documentElement['clientHeight']
        window.onresize = () => {
          this.documentClientHeight = document.documentElement['clientHeight']
        }
      },
      // 获取当前管理员信息
      getUserInfo () {
        this.loading = false;
      },

      // 获取全部交易中心列表  
      getTransactionCenterList () {
        this.$http.post('/suite/loadTrades', {}).then(res => {
          this.$store.commit('common/updateTransactionCenterList', JSON.stringify(res.data || '[]'))
          sessionStorage.setItem("transactionCenterList", JSON.stringify(res.data || '[]'));
        })
      },

      // 获取全部应用列表  
      getAppList () {
        this.$http.post('/thirdsConfig/appList', {
          page: 1,
          rows: 999,
          searchKey: "",
          filter: {}
        }).then(res => {
          this.$store.commit('common/updateAppList', JSON.stringify(res.data.rows || '[]'))
          sessionStorage.setItem("appList", JSON.stringify(res.data.rows || '[]'));
        })
      },

    }
  }
</script>
<style lang="less" scoped>

</style>